import { useTranslation } from "react-i18next";

import { FormContainer, Treturn, useFetch } from "@4uhub/lib4uhub";
import { useCallback } from "react";
import {
  createTicketAutomationMessageRule,
  getTicketAutomationMessageRuleById,
  updateTicketAutomationMessageRuleById,
} from "../../../../../../../services/ticketAutomationMessageRules.service";
import { ITimeRuleProps } from "../../TimeRules/TimeRuleForm/models";
import { MessageFields } from "./MessageFields";
import { TMessageForm, messageSchema } from "./messageSchema";

const translationPath = "components.messages.";

const Message = ({
  id,
  ticketAutomationRuleId,
  onBackButton,
}: ITimeRuleProps) => {
  const { t } = useTranslation();

  const { sendRequest: save, loading: sLoading } = useFetch(
    createTicketAutomationMessageRule,
  );

  const { sendRequest: update, loading: uLoading } = useFetch(
    updateTicketAutomationMessageRuleById,
  );

  const { sendRequest: get, loading: gLoading } = useFetch(
    getTicketAutomationMessageRuleById,
  );

  const saveHandler = (v: TMessageForm) =>
    save({
      ...v,
      establishments: v.establishments
        ? v.establishments.map((e) => e.id)
        : undefined,
      tasyScheduleRecords: v.tasyScheduleRecords
        ? v.tasyScheduleRecords.map((sr) => sr.id)
        : undefined,
      tasyScheduleClassifications: v.tasyScheduleClassifications
        ? v.tasyScheduleClassifications.map((sc) => sc.id)
        : undefined,
      tasyScheduleTypes: v.tasyScheduleTypes
        ? v.tasyScheduleTypes.map((st) => st.id)
        : undefined,
      tasyHealthInsurances: v.tasyHealthInsurances
        ? v.tasyHealthInsurances.map((hi) => hi.id)
        : undefined,
      calendarPreferences: v.calendarPreferences
        ? v.calendarPreferences.map((cp) => ({
            preferenceExternalId: cp.id,
            preferenceExternalName: cp.name,
          }))
        : undefined,
      tasyAuthStatuses: v.tasyAuthStatuses
        ? v.tasyAuthStatuses.map((cp) => ({
            externalId: cp.id,
            name: cp.name,
          }))
        : undefined,
      tasyCalendarStatuses: v.tasyCalendarStatuses
        ? v.tasyCalendarStatuses.map((cp) => ({
            externalId: cp.id,
            name: cp.name,
          }))
        : undefined,
      surgeryTypes: v.surgeryTypes
        ? v.surgeryTypes.map((cp) => ({
            externalId: cp.id,
            externalName: cp.name,
          }))
        : undefined,
      surgeryPortes: v.surgeryPortes
        ? v.surgeryPortes.map((cp) => ({
            externalId: cp.id,
            externalName: cp.name,
          }))
        : undefined,
      surgeryCareCharacters: v.surgeryCareCharacters
        ? v.surgeryCareCharacters.map((cp) => ({
            externalId: cp.id,
            externalName: cp.name,
          }))
        : undefined,
      surgeryServiceSectors: v.surgeryServiceSectors
        ? v.surgeryServiceSectors.map((cp) => ({
            externalId: cp.id,
            externalName: cp.name,
          }))
        : undefined,
      surgeryHealthInsurances: v.surgeryHealthInsurances
        ? v.surgeryHealthInsurances.map((cp) => ({
            externalId: cp.id,
            externalName: cp.name,
          }))
        : undefined,
      calendarHistoryType: v.calendarHistoryType
        ? v.calendarHistoryType
        : undefined,
      ticketAutomationRuleId: ticketAutomationRuleId ?? "",
      evaluationFormId: v.evaluationForm ? v.evaluationForm.id : undefined,
      ticketAutRoundSchedulesDateId: v.ticketAutRoundSchedulesDate
        ? v.ticketAutRoundSchedulesDate.id
        : undefined,
      appointmentArrivalRuleId: v.appointmentArrivalRule?.id,
      esignRules: v.esignRules ? v.esignRules.map((sr) => sr.id) : undefined,
      scheduleReminderFilterTypeId: v.scheduleReminderFilterType
        ? v.scheduleReminderFilterType.id
        : undefined,
      initialDate: v.initialDate.toISOString().substring(0, 10),
      endDate: v.endDate.toISOString().substring(0, 10),
      mediaFilesIds: [],
      deleteMediaFilesIds: [],
      ticketChannelStepWhenNotId: v.ticketChannelStepWhenNot
        ? v.ticketChannelStepWhenNot.id
        : undefined,
      ticketChannelStepWhenCancelId: v.ticketChannelStepWhenCancel
        ? v.ticketChannelStepWhenCancel.id
        : undefined,
      ticketChannelStepWhenNotMeId: v.ticketChannelStepWhenNotMe
        ? v.ticketChannelStepWhenNotMe.id
        : undefined,
      ticketChannelStepWhenConfirmId: v.ticketChannelStepWhenConfirm
        ? v.ticketChannelStepWhenConfirm.id
        : undefined,
      ticketChannelStepWhenAttendantId: v.ticketChannelStepWhenAttendant
        ? v.ticketChannelStepWhenAttendant.id
        : undefined,
      activeServiceSearchSurveyTypeId: v.activeServiceSearchSurveyType
        ? v.activeServiceSearchSurveyType.id
        : undefined,
      qtyPacientSent: v.qtyPacientSent ? Number(v.qtyPacientSent) : undefined,
      priority: v.priority ? Number(v.priority) : undefined,
      origin: v.origin ? v.origin : undefined,
      schedulingMethod: v.schedulingMethod ? v.schedulingMethod : undefined,
      serviceClassification: v.serviceClassification
        ? v.serviceClassification
        : undefined,
      serviceSector: v.serviceSector ? v.serviceSector : undefined,
      serviceType: v.serviceType ? v.serviceType : undefined,
      serviceComplaint: v.serviceComplaint ? v.serviceComplaint : undefined,
      groupingIdentifier: v.groupingIdentifier
        ? v.groupingIdentifier
        : undefined,
      integrationType: v.integrationType ? v.integrationType : undefined,
      cancellationReasonCode: v.cancellationReasonCode
        ? v.cancellationReasonCode
        : undefined,
      cancellationReasonDescription:
        !v.cancellationReasonCode?.includes(",") &&
        v.cancellationReasonDescription
          ? v.cancellationReasonDescription
          : undefined,

      examCancellationReasonCode: v.examCancellationReasonCode
        ? v.examCancellationReasonCode
        : undefined,
      examCancellationReasonDescription:
        !v.examCancellationReasonCode?.includes(",") &&
        v.examCancellationReasonDescription
          ? v.examCancellationReasonDescription
          : undefined,

      surgeryCancellationReasonCode: v.surgeryCancellationReasonCode
        ? v.surgeryCancellationReasonCode
        : undefined,
      surgeryCancellationReasonDescription:
        !v.surgeryCancellationReasonCode?.includes(",") &&
        v.surgeryCancellationReasonDescription
          ? v.surgeryCancellationReasonDescription
          : undefined,

      internalProcedure: v.internalProcedure ? v.internalProcedure : undefined,
      individualIdentifier: v.individualIdentifier
        ? v.individualIdentifier
        : undefined,
      qtyMessageSendingAttempts: v.qtyMessageSendingAttempts
        ? Number(v.qtyMessageSendingAttempts)
        : undefined,
      indicationSequence: v.indicationSequence
        ? v.indicationSequence
        : undefined,
      usePatientEncounterInfoPhone: v.usePatientEncounterInfoPhone,
      missingStatusId: v.missingStatus ? v.missingStatus.id : undefined,
    });

  const updateHandler = (v: TMessageForm, id: string) =>
    update({
      item: {
        id: id,
        ...v,
        establishments: v.establishments
          ? v.establishments.map((e) => e.id)
          : undefined,
        tasyScheduleRecords: v.tasyScheduleRecords
          ? v.tasyScheduleRecords.map((sr) => sr.id)
          : undefined,
        tasyScheduleClassifications: v.tasyScheduleClassifications
          ? v.tasyScheduleClassifications.map((sc) => sc.id)
          : undefined,
        tasyScheduleTypes: v.tasyScheduleTypes
          ? v.tasyScheduleTypes.map((st) => st.id)
          : undefined,
        tasyHealthInsurances: v.tasyHealthInsurances
          ? v.tasyHealthInsurances.map((hi) => hi.id)
          : undefined,
        calendarPreferences: v.calendarPreferences
          ? v.calendarPreferences.map((cp) => ({
              preferenceExternalId: cp.id,
              preferenceExternalName: cp.name,
            }))
          : undefined,
        tasyAuthStatuses: v.tasyAuthStatuses
          ? v.tasyAuthStatuses.map((cp) => ({
              externalId: cp.id,
              name: cp.name,
            }))
          : undefined,
        tasyCalendarStatuses: v.tasyCalendarStatuses
          ? v.tasyCalendarStatuses.map((cp) => ({
              externalId: cp.id,
              name: cp.name,
            }))
          : undefined,
        surgeryTypes: v.surgeryTypes
          ? v.surgeryTypes.map((cp) => ({
              externalId: cp.id,
              externalName: cp.name,
            }))
          : undefined,
        surgeryPortes: v.surgeryPortes
          ? v.surgeryPortes.map((cp) => ({
              externalId: cp.id,
              externalName: cp.name,
            }))
          : undefined,
        surgeryCareCharacters: v.surgeryCareCharacters
          ? v.surgeryCareCharacters.map((cp) => ({
              externalId: cp.id,
              externalName: cp.name,
            }))
          : undefined,
        surgeryServiceSectors: v.surgeryServiceSectors
          ? v.surgeryServiceSectors.map((cp) => ({
              externalId: cp.id,
              externalName: cp.name,
            }))
          : undefined,
        surgeryHealthInsurances: v.surgeryHealthInsurances
          ? v.surgeryHealthInsurances.map((cp) => ({
              externalId: cp.id,
              externalName: cp.name,
            }))
          : undefined,
        calendarHistoryType: v.calendarHistoryType
          ? v.calendarHistoryType
          : undefined,
        ticketAutomationRuleId: ticketAutomationRuleId ?? "",
        evaluationFormId: v.evaluationForm ? v.evaluationForm.id : undefined,
        ticketAutRoundSchedulesDateId: v.ticketAutRoundSchedulesDate
          ? v.ticketAutRoundSchedulesDate.id
          : undefined,
        appointmentArrivalRuleId: v.appointmentArrivalRule?.id,
        esignRules: v.esignRules ? v.esignRules.map((sr) => sr.id) : undefined,
        scheduleReminderFilterTypeId: v.scheduleReminderFilterType
          ? v.scheduleReminderFilterType.id
          : undefined,
        initialDate: v.initialDate.toISOString().substring(0, 10),
        endDate: v.endDate.toISOString().substring(0, 10),
        mediaFilesIds: [],
        deleteMediaFilesIds: [],
        ticketChannelStepWhenNotId: v.ticketChannelStepWhenNot
          ? v.ticketChannelStepWhenNot.id
          : undefined,
        ticketChannelStepWhenCancelId: v.ticketChannelStepWhenCancel
          ? v.ticketChannelStepWhenCancel.id
          : undefined,
        ticketChannelStepWhenNotMeId: v.ticketChannelStepWhenNotMe
          ? v.ticketChannelStepWhenNotMe.id
          : undefined,
        ticketChannelStepWhenConfirmId: v.ticketChannelStepWhenConfirm
          ? v.ticketChannelStepWhenConfirm.id
          : undefined,
        ticketChannelStepWhenAttendantId: v.ticketChannelStepWhenAttendant
          ? v.ticketChannelStepWhenAttendant.id
          : undefined,
        activeServiceSearchSurveyTypeId: v.activeServiceSearchSurveyType
          ? v.activeServiceSearchSurveyType.id
          : undefined,
        qtyPacientSent: v.qtyPacientSent ? Number(v.qtyPacientSent) : undefined,
        priority: v.priority ? Number(v.priority) : undefined,
        origin: v.origin ? v.origin : undefined,
        schedulingMethod: v.schedulingMethod ? v.schedulingMethod : undefined,
        serviceClassification: v.serviceClassification
          ? v.serviceClassification
          : undefined,
        serviceSector: v.serviceSector ? v.serviceSector : undefined,
        serviceType: v.serviceType ? v.serviceType : undefined,
        serviceComplaint: v.serviceComplaint ? v.serviceComplaint : undefined,
        groupingIdentifier: v.groupingIdentifier
          ? v.groupingIdentifier
          : undefined,
        integrationType: v.integrationType ? v.integrationType : undefined,
        cancellationReasonCode: v.cancellationReasonCode
          ? v.cancellationReasonCode
          : undefined,
        cancellationReasonDescription:
          !v.cancellationReasonCode?.includes(",") &&
          v.cancellationReasonDescription
            ? v.cancellationReasonDescription
            : undefined,
        examCancellationReasonCode: v.examCancellationReasonCode
          ? v.examCancellationReasonCode
          : undefined,
        examCancellationReasonDescription:
          !v.examCancellationReasonCode?.includes(",") &&
          v.examCancellationReasonDescription
            ? v.examCancellationReasonDescription
            : undefined,
        surgeryCancellationReasonCode: v.surgeryCancellationReasonCode
          ? v.surgeryCancellationReasonCode
          : undefined,
        surgeryCancellationReasonDescription:
          !v.surgeryCancellationReasonCode?.includes(",") &&
          v.surgeryCancellationReasonDescription
            ? v.surgeryCancellationReasonDescription
            : undefined,
        internalProcedure: v.internalProcedure
          ? v.internalProcedure
          : undefined,
        individualIdentifier: v.individualIdentifier
          ? v.individualIdentifier
          : undefined,
        qtyMessageSendingAttempts: v.qtyMessageSendingAttempts
          ? Number(v.qtyMessageSendingAttempts)
          : undefined,
        indicationSequence: v.indicationSequence
          ? v.indicationSequence
          : undefined,
        usePatientEncounterInfoPhone: v.usePatientEncounterInfoPhone,
        missingStatusId: v.missingStatus ? v.missingStatus.id : undefined,
      },
      id: id,
    });

  const getHandler = useCallback(
    async (id: string): Promise<Treturn<TMessageForm>> => {
      const { data, success } = await get(id);

      if (data) {
        const newData: TMessageForm = {
          ...data,
          isRequiredCancellation: false,
          moveTicket: !!data.ticketChannelStepWhenNot,
          moveTicketCancel: !!data.ticketChannelStepWhenCancel,
          moveTicketNotMe: !!data.ticketChannelStepWhenNotMe,
          moveTicketConfirm: !!data.ticketChannelStepWhenConfirm,
          moveTicketAttendant: !!data.ticketChannelStepWhenAttendant,
          initialDate: new Date(`${data.initialDate}T12:00:00Z`),
          endDate: new Date(`${data.endDate}T12:00:00Z`),
          tasyScheduleRecords: data.tasyScheduleRecords?.map((item: any) => ({
            id: item.id,
            name: item.name + " - " + item.code,
            code: item.code,
          })),
          evaluationForm: data.evaluationForm
            ? {
                id: data.evaluationForm.id,
                name: data.evaluationForm.title,
              }
            : null,
          ticketChannelStepWhenNot: data.ticketChannelStepWhenNot,
          ticketChannelWhenNot: data.ticketChannelStepWhenNot
            ? data.ticketChannelStepWhenNot.ticketChannel
            : null,
          ticketChannelStepWhenCancel: data.ticketChannelStepWhenCancel,
          ticketChannelWhenCancel: data.ticketChannelStepWhenCancel
            ? data.ticketChannelStepWhenCancel.ticketChannel
            : null,
          ticketChannelStepWhenNotMe: data.ticketChannelStepWhenNotMe,
          ticketChannelWhenNotMe: data.ticketChannelStepWhenNotMe
            ? data.ticketChannelStepWhenNotMe.ticketChannel
            : null,
          ticketChannelStepWhenConfirm: data.ticketChannelStepWhenConfirm,
          ticketChannelWhenConfirm: data.ticketChannelStepWhenConfirm
            ? data.ticketChannelStepWhenConfirm.ticketChannel
            : null,
          ticketChannelStepWhenAttendant: data.ticketChannelStepWhenAttendant,
          ticketChannelWhenAttendant: data.ticketChannelStepWhenAttendant
            ? data.ticketChannelStepWhenAttendant.ticketChannel
            : undefined,
          activeServiceSearchSurveyType: data.activeServiceSearchSurveyType,
          appointmentArrivalRule: data.appointmentArrivalRule,
          qtyPacientSent: data.qtyPacientSent
            ? String(data.qtyPacientSent)
            : "",
          priority: data.priority ? String(data.priority) : null,
          origin: data.origin ? data.origin : null,
          schedulingMethod: data.schedulingMethod
            ? data.schedulingMethod
            : null,
          serviceClassification: data.serviceClassification
            ? data.serviceClassification
            : null,
          serviceSector: data.serviceSector ? data.serviceSector : null,
          serviceType: data.serviceType ? data.serviceType : null,
          serviceComplaint: data.serviceComplaint
            ? data.serviceComplaint
            : null,
          groupingIdentifier: data.groupingIdentifier
            ? data.groupingIdentifier
            : null,
          integrationType: data.integrationType ? data.integrationType : null,
          cancellationReasonCode: data.cancellationReasonCode
            ? data.cancellationReasonCode
            : null,
          cancellationReasonDescription: data.cancellationReasonDescription
            ? data.cancellationReasonDescription
            : null,

          examCancellationReasonCode: data.examCancellationReasonCode
            ? data.examCancellationReasonCode
            : null,

          examCancellationReasonDescription:
            data.examCancellationReasonDescription
              ? data.examCancellationReasonDescription
              : null,

          surgeryCancellationReasonCode: data.surgeryCancellationReasonCode
            ? data.surgeryCancellationReasonCode
            : null,

          surgeryCancellationReasonDescription:
            data.surgeryCancellationReasonDescription
              ? data.surgeryCancellationReasonDescription
              : null,

          internalProcedure: data.internalProcedure
            ? data.internalProcedure
            : null,
          individualIdentifier: data.individualIdentifier
            ? data.individualIdentifier
            : null,
          qtyMessageSendingAttempts: data.qtyMessageSendingAttempts
            ? String(data.qtyMessageSendingAttempts)
            : null,
          indicationSequence: data.indicationSequence
            ? data.indicationSequence
            : null,
          usePatientEncounterInfoPhone: data.usePatientEncounterInfoPhone,
          missingStatus: data.missingStatus
            ? data.missingStatus
            : data.missingStatusId
              ? {
                  id: data.missingStatusId,
                  name: "",
                  code: null,
                }
              : null,
          calendarPreferences: data.ticketAutomationMessagePreferences
            ? data.ticketAutomationMessagePreferences.map((cp) => ({
                id: cp.preferenceExternalId,
                name: cp.preferenceExternalName,
              }))
            : undefined,
          tasyAuthStatuses: data.ticketAutomationMessageTasyAuthStatuses
            ? data.ticketAutomationMessageTasyAuthStatuses.map((cp) => ({
                id: cp.externalId,
                name: cp.name,
              }))
            : undefined,
          tasyCalendarStatuses: data.ticketAutomationMessageTasyCalendarStatuses
            ? data.ticketAutomationMessageTasyCalendarStatuses.map((cp) => ({
                id: cp.externalId,
                name: cp.name,
              }))
            : undefined,
          surgeryTypes: data.ticketAutomationMessageSurgeryTypes
            ? data.ticketAutomationMessageSurgeryTypes.map((cp) => ({
                id: cp.externalId,
                name: cp.externalName,
              }))
            : undefined,
          surgeryPortes: data.ticketAutomationMessageSurgeryPortes
            ? data.ticketAutomationMessageSurgeryPortes.map((cp) => ({
                id: cp.externalId,
                name: cp.externalName,
              }))
            : undefined,
          surgeryCareCharacters:
            data.ticketAutomationMessageSurgeryCareCharacters
              ? data.ticketAutomationMessageSurgeryCareCharacters.map((cp) => ({
                  id: cp.externalId,
                  name: cp.externalName,
                }))
              : undefined,
          surgeryServiceSectors:
            data.ticketAutomationMessageSurgeryServiceSectors
              ? data.ticketAutomationMessageSurgeryServiceSectors.map((cp) => ({
                  id: cp.externalId,
                  name: cp.externalName,
                }))
              : undefined,
          surgeryHealthInsurances:
            data.ticketAutomationMessageSurgeryHealthInsurances
              ? data.ticketAutomationMessageSurgeryHealthInsurances.map(
                  (cp) => ({
                    id: cp.externalId,
                    name: cp.externalName,
                  }),
                )
              : undefined,
          calendarHistoryType: data.calendarHistoryType
            ? data.calendarHistoryType
            : undefined,
        };
        return { data: newData, success: true };
      }
      return { data, success };
    },
    [get],
  );

  const loading = sLoading || uLoading || gLoading;

  return (
    <FormContainer<TMessageForm>
      saveFunction={saveHandler}
      updateFunction={updateHandler}
      getFunction={getHandler}
      loading={loading}
      title={t(translationPath + "message")}
      schema={messageSchema}
      subtitle={t(translationPath + "new_message")}
      subtitleWatchField={"name"}
      backButtonOnClick={onBackButton}
      redirectOnSave={false}
      onSuccess={onBackButton}
      isModalForm={true}
      propId={id}
      formActionsOnBottom={false}
      defaultValues={{
        exception: false,
        moveTicket: false,
        moveTicketCancel: false,
        moveTicketNotMe: false,
        moveTicketConfirm: false,
        moveTicketAttendant: false,
        isRequiredCancellation: false,
        sendToConfimed: false,
        confirmScheduleWithOk: false,
        usePatientEncounterInfoPhone: false,
        missingStatus: null,
      }}
      fields={() => <MessageFields idMessage={id} />}
    />
  );
};

export default Message;
